import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import vuetify from './plugins/vuetify';
import * as dayjs from 'dayjs'
import 'dayjs/locale/es'
dayjs.locale('es')


Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')


Vue.filter('formatdate', function (value) {
  if (!value) return ''
      value = dayjs(value).format('DD/MM/YYYY')
      return value;
})